<template>
  <div class="percentage-meter">
    <span :id="labelId" class="percentage-meter__label">{{ label }}</span>
    <div
      class="percentage-meter__track"
      role="progressbar"
      :aria-labelledby="labelId"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-valuenow="boundedPercentage"
    >
      <span
        class="percentage-meter__fill"
        :style="{ width: `${boundedPercentage}%` }"
      ></span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

let percentageMeterInstanceCount = 0;

defineOptions({
  name: "PercentageMeter",
});

const props = defineProps({
  percentage: {
    type: Number,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const labelId = `percentage-meter-label-${++percentageMeterInstanceCount}`;
const boundedPercentage = computed(() => {
  const value = Number(props.percentage);
  if (!Number.isFinite(value)) return 0;
  return Math.min(100, Math.max(0, value));
});
</script>

<style scoped>
.percentage-meter {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.percentage-meter__label {
  margin-bottom: var(--space-2);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-bold);
  text-align: center;
}

.percentage-meter__track {
  position: relative;
  width: 100%;
  height: var(--space-5);
  overflow: hidden;
  border-radius: var(--radius-sm);
  background: var(--color-control-track);
}

.percentage-meter__fill {
  position: absolute;
  inset-block: 0;
  inset-inline-start: 0;
  border-radius: inherit;
  background: var(--color-control-fill-muted);
}
</style>
